import { render, staticRenderFns } from "./SpasmsCounter.vue?vue&type=template&id=2e09620a&scoped=true&"
import script from "./SpasmsCounter.vue?vue&type=script&lang=js&"
export * from "./SpasmsCounter.vue?vue&type=script&lang=js&"
import style0 from "./SpasmsCounter.vue?vue&type=style&index=0&id=2e09620a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e09620a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
